import { render, staticRenderFns } from "./choose_medical.vue?vue&type=template&id=59548efc&scoped=true"
import script from "./choose_medical.vue?vue&type=script&lang=js"
export * from "./choose_medical.vue?vue&type=script&lang=js"
import style0 from "./choose_medical.vue?vue&type=style&index=0&id=59548efc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59548efc",
  null
  
)

export default component.exports